import React, { useEffect, useState, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { CountryStatusCssClasses } from "../CountriesUIHelpers";
import * as actions from "../../../../_redux/countries/countriesActions";
import { useCountriesUIContext } from "../CountriesUIContext";

const selectedCountries = (entities, ids) => {
  const _countries = [];
  ids.forEach((id) => {
    const country = entities.find((el) => el._id === id);
    if (country) {
      _countries.push(country);
    }
  });
  return _countries;
};

export function CountriesUpdateStateDialog({ show, onHide }) {
  // Countries UI Context
  const countriesUIContext = useCountriesUIContext();
  const countriesUIProps = useMemo(() => {
    return {
      ids: countriesUIContext.ids,
      setIds: countriesUIContext.setIds,
      queryParams: countriesUIContext.queryParams,
    };
  }, [countriesUIContext]);

  // Countries Redux state
  const { countries, isLoading } = useSelector(
    (state) => ({
      countries: selectedCountries(
        state.countries.entities,
        countriesUIProps.ids
      ),
      isLoading: state.countries.actionsLoading,
    }),
    shallowEqual
  );

  // if !id we should close modal
  useEffect(() => {
    if (!countriesUIProps.ids || countriesUIProps.ids.length === 0) {
      onHide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countriesUIProps.ids]);

  const [status, setStatus] = useState(2);

  const dispatch = useDispatch();
  const updateStatus = () => {
    // server request for update countries status by selected ids
    dispatch(actions.updateCountriesStatus(countriesUIProps.ids, status)).then(
      () => {
        // refresh list after deletion
        dispatch(actions.fetchCountries(countriesUIProps.queryParams)).then(
          () => {
            // clear selections list
            countriesUIProps.setIds([]);
            // closing delete modal
            onHide();
          }
        );
      }
    );
  };
  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          Status Will be updated for selected Countries
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="overlay overlay-block">
        {/*begin::Loading*/}
        {isLoading && (
          <div className="overlay-layer">
            <div className="spinner spinner-lg spinner-primary" />
          </div>
        )}
        {/*end::Loading*/}

        <div className="timeline timeline-5 mt-3">
          {countries.map((country) => (
            <div
              className="timeline-item align-items-start"
              key={`countriesUpdate${country._id}`}
            >
              <div className="timeline-label font-weight-bolder text-dark-75 font-size-lg text-right pr-3" />
              <div className="timeline-badge">
                <i
                  className={`fa fa-genderless text-${
                    CountryStatusCssClasses[country.status]
                  } icon-xxl`}
                />
              </div>
              <div className="timeline-content text-dark-50 mr-5">
                <span
                  className={`label label-lg label-light-${
                    CountryStatusCssClasses[country.status]
                  } label-inline`}
                >
                  ID: {country._id}
                </span>
                <span className="ml-3">
                  {country.countryEmail}
                </span>
              </div>
            </div>
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer className="form">
        <div className="form-group">
          <select
            className="form-control"
            value={status}
            onChange={(e) => setStatus(+e.target.value)}
          >
            <option value="0">Pending</option>
            <option value="1">Sent</option>
            <option value="2">Rejected</option>

          </select>
        </div>
        <div className="form-group">
          <button
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate mr-3"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={updateStatus}
            className="btn btn-primary btn-elevate"
          >
            Update Status
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
